import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `PUT /client/:cid/users/:id/permissions {administrator?, fleet?}`: cb's four grant and revoke routes. */
export const setUserPermissions = async (
  user_id: string,
  permissions: { administrator?: boolean; fleet?: boolean }
): Promise<any> => {
  await lpRequest('PUT', clientPath(`/users/${user_id}/permissions`), { body: permissions });

  return getUser(user_id);
};
